<template>
  <v-layout row wrap>
    <v-flex shrink v-if="advancedSearch">
      <v-tooltip bottom>
        <v-btn
          style="min-width: 64px !important; height: 48px; margin:0 10px 0; padding: 0; background: white"
          :class="{ 'ml-0': !$vuetify.rtl, 'mr-0': $vuetify.rtl }"
          slot="activator"
          @click="toggleAdvancedSearch"
          class="grey--text text--darken-2"
        >
          <v-icon>filter_list</v-icon>
          <!--          {{ $t('Filter') }}-->
        </v-btn>
        <span>{{ $t('Advanced Search') }}</span>
      </v-tooltip>
    </v-flex>
    <v-flex xs5 :class="searchWidth">
      <v-text-field
        v-model="searchValue"
        @keyup.enter="inputChanged()"
        prepend-inner-icon="search"
        :label="$t('datatable-search')"
        clearable
        solo
        @click:clear="searchValue = ''"
        single-line
        hide-details
      />
    </v-flex>
    <v-flex shrink v-if="!advancedSearchStatus" pr-2 pl-2>
      <v-btn color="success" @click="inputChanged">
        <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">search</v-icon>
        {{ $t('Search') }}
      </v-btn>
      <v-btn flat class="grey--text" @click="clearSearch">
        <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">clear</v-icon>
        {{ $t('datatable-reset') }}
      </v-btn>
    </v-flex>

    <v-expand-transition>
      <v-flex xs12 pa-2 v-if="advancedSearchStatus">
        <slot name="form" :search="inputChanged" :reset="clearSearch" />
      </v-flex>
    </v-expand-transition>
  </v-layout>
</template>

<script>
export default {
  name: 'dt-search-box',

  props: {
    searchWidth: { type: String, required: false },
    advancedSearch: { type: Boolean, required: false, default: false }
  },

  data() {
    return {
      searchValue: '',
      advancedSearchStatus: false
    }
  },

  methods: {
    inputChanged() {
      this.$emit('typing', this.searchValue)
    },
    clearSearch() {
      this.searchValue = ''
      this.$emit('clear-search-field')
      this.$emit('reset-datatable')
    },
    toggleAdvancedSearch() {
      this.advancedSearchStatus = !this.advancedSearchStatus
      this.$emit('reset-advanced-search')
    }
  }
  // updated () {
  //   document.addEventListener('keyup', (e) => {
  //     // if the "ESC" button was pressed and this dialog is shown, hide it
  //     if (e.keyCode === 27 && this.deleteDialog) {
  //       // console.log('ESC button pressed from the delete modal')
  //       this.$emit('hidemodal')
  //     }
  //   })
  // }
}
</script>
